import uploadCenter from '@/utils/uploadCenter'

export default {
  computed: {
    paperUploadTasks: {
      get() {
        return uploadCenter.state.tasks
      },
      set(value) {
        uploadCenter.state.tasks = Array.isArray(value) ? value : []
      }
    },
    paperUploadListVisible: {
      get() {
        return uploadCenter.state.visible
      },
      set(value) {
        uploadCenter.state.visible = !!value
      }
    },
    paperUploadPanelCollapsed: {
      get() {
        return uploadCenter.state.collapsed
      },
      set(value) {
        uploadCenter.state.collapsed = !!value
      }
    }
  },
  methods: {
    $enqueuePaperUploadTask(task, runner, cancel) {
      uploadCenter.addTask(task, {
        retry: () => {
          if (typeof runner == 'function') {
            runner(task)
          }
        },
        cancel: () => {
          if (typeof cancel == 'function') {
            return cancel(task)
          }
        }
      })
      if (typeof runner == 'function') {
        runner(task)
      }
      return true
    }
  }
}
